import { useState, useEffect } from 'react';
import { useGetJobsQuery } from '@/store/query/ats';
import { useMemo } from 'react';
import { MenuSelect } from '@/pages/reports/ats-reports/components/menu-select';

export const GroupBy = ({
  selected = null,
  onChange = () => {},
  isEditMode = false,
  isPortal = false,
}) => {
  const { data: jobs } = useGetJobsQuery();
  const [currSelected, setSelected] = useState();
  const onSelect = (option) => {
    setSelected(option);
    onChange(option);
  };

  const options = useMemo(() => {
    const allFilters = [
      { id: null, label: 'Time' },
      { id: 'flow', label: 'Flow' },
      { id: 'recruiter', label: 'Recruiter' },
      { id: 'company', label: 'Company' },
      { id: 'location', label: 'Location' },
      { id: 'school', label: 'School' },
      { id: 'source', label: 'Source' },
    ];
    const atsFilters = [
      { id: 'department', label: 'Department' },
      { id: 'job_name', label: 'Job name' },
    ];

    if (jobs?.options?.length) {
      return [...allFilters, ...atsFilters];
    }
    return allFilters;
  }, [jobs]);

  useEffect(() => {
    if (selected) {
      const currSelected = options?.find((option) => option.id === selected);
      setSelected(currSelected);
      return;
    }
    setSelected(options[0]);
  }, [selected]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MenuSelect
      editMode={isEditMode}
      options={options}
      selected={currSelected}
      onSelect={onSelect}
      prefix="Group by"
      isPortal={isPortal}
    />
  );
};
